// extracted by mini-css-extract-plugin
module.exports = {"loginWithGoogleBtn":"googleLogin_loginWithGoogleBtn__2tp1s"};